function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { onMounted, ref } from 'vue';
import { defineStore } from 'pinia';
import { onServerPrefetch, useRoute } from '#imports';
import { getLangFallbackUrl } from '~/lang/utils/langfetch';
var destnationsCache = {};
export var usePopularDestinationsStore = defineStore('popularDestinations', () => {
  var _config$axios;
  var route = useRoute();
  var config = useRuntimeConfig();
  var baseURL = (_config$axios = config.axios) === null || _config$axios === void 0 ? void 0 : _config$axios.baseURL;
  var locations = ref([]);
  var fetchData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* () {
      var _destnationsCache$lan;
      var langCode = route.params.lang || 'en-gb';
      if ((_destnationsCache$lan = destnationsCache[langCode]) !== null && _destnationsCache$lan !== void 0 && _destnationsCache$lan.length) {
        locations.value = destnationsCache[langCode];
        return;
      }
      var url = getLangFallbackUrl(langCode, '/search2/destinations/?limit=16');
      var response = yield $fetch(url, {
        baseURL,
        timeout: 10000
      });
      locations.value = response;
      destnationsCache[langCode] = response;
    });
    return function fetchData() {
      return _ref.apply(this, arguments);
    };
  }();
  if (process.server) {
    // Fetch data on server-side rendering
    onServerPrefetch( /*#__PURE__*/_asyncToGenerator(function* () {
      yield fetchData();
    }));
  }

  // Fetch data on client-side rendering
  onMounted( /*#__PURE__*/_asyncToGenerator(function* () {
    yield fetchData();
  }));
  return {
    locations
  };
});